module.exports = __webpack_public_path__ + "img/lock-1.f51b690a.svg";